import { AppSettings, City } from 'src/types';

export const cityAdapter = (cityObject: City | null): string | undefined => {
  if (!cityObject) {
    return;
  }

  return cityObject.name as string;
};

export const citiesListFromAppSettings = (config: AppSettings) => {
  return config.cities.map((city) => ({ value: city.id, label: city.name }));
};
